<template>
  <div class="my-4">
    <b-badge class="bg-orange">
      <span class="mr-2 c-white font-weight-normal fs-22"> Visualizações </span>
      <b-badge variant="light fs-20 ">
        <i class="far fa-eye fs-16 c-black mr-2"></i>
        <span class="c-black">{{ numberOfVisualizations }}</span>
      </b-badge>
    </b-badge>
  </div>
</template>
<script>
export default {
  props: {
    numberOfVisualizations: {
      type: Number,
      required: true,
    },
  },
};
</script>
